import { FC, ReactNode } from 'react';

import { DialogClose } from '@radix-ui/react-dialog';

import { CloseIcon } from '@/assets/icons';
import { IconButton } from '@/components';
import { EDIT_CELL_WRAPPER_TEST_IDS } from '@/constants/data-testids';

import { DialogContent } from '../../../../atoms/Dialog/Dialog';

type EditCellWrapperProps = {
  chartContent: ReactNode;
  sideBarContent: ReactNode;
};

export const EditCellWrapper: FC<EditCellWrapperProps> = ({ chartContent, sideBarContent }) => {
  return (
    <DialogContent className="max-w-[1132px] max-h-[508px] h-full w-full">
      <div className="relative flex items-center gap-6">
        <div
          data-testid={EDIT_CELL_WRAPPER_TEST_IDS.CHART}
          className="max-w-[760px] w-full h-full flex items-center justify-center bg-custom-warm-grey-100 border border-custom-warm-grey-200 rounded-[12px] px-8"
        >
          {chartContent}
        </div>
        <div
          data-testid={EDIT_CELL_WRAPPER_TEST_IDS.SIDEBAR}
          className="max-w-[300px] w-full h-full"
        >
          {sideBarContent}
        </div>

        <DialogClose
          className="cursor-pointer absolute -top-2.5 -right-2.5 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-5"
          asChild
        >
          <IconButton
            data-testid={EDIT_CELL_WRAPPER_TEST_IDS.CLOSE_BUTTON}
            variant="teritary"
            size="sm"
            icon={<CloseIcon width={20} height={20} className="text-custom-warm-grey-400" />}
          />
        </DialogClose>
      </div>
    </DialogContent>
  );
};
